import { call, take, put } from 'redux-saga/effects'
import { GET_FLEET_INFORMATION, UPDATE_FLEET } from 'actions/fleet'
import { fleet } from 'services'

export default function* watchUpdateFleet() {
  while (true) {
    const {
      serialNumber,
      notes,
      ptoExclusions,
      featuresExclusions,
      setPto,
      setFeatures,
    } = yield take(UPDATE_FLEET)

    try {
      const response = yield call(fleet.update, {
        serialNumber,
        notes,
        ptoExclusions,
        featuresExclusions,
        setPto,
        setFeatures,
      })
      const { data } = response
      yield put({
        type: GET_FLEET_INFORMATION,
        vehicles: data,
      })
    } catch (err) {
      // Error handling now managed by SignalR FleetUpdateBanner
      console.error('Fleet update failed:', err)
    }
  }
}
